import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
	selector: 'app-page-dialog',
	standalone: true,
	imports: [MatCardModule],
	templateUrl: './page-dialog.component.html',
	styleUrl: './page-dialog.component.scss'
})
export class PageDialogComponent {

}
